import {Component, Input, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {DeviceFullDTO} from 'src/app/services/api/api';
import {DeviceService} from '../../../services/device/deviceService';

@Component({
  selector: '[sb-device-online-status-icon]',
  templateUrl: './sb-device-online-status-icon.component.html',
  styleUrls: ['./sb-device-online-status-icon.component.scss'],
  standalone: false,
})
export class SbDeviceOnlineStatusIconComponent implements OnInit {
  @Input() device: DeviceFullDTO;
  @Input() tooltipPlacement: string;

  constructor(
    public translate: TranslateService,
    public deviceService: DeviceService
  ) {}

  ngOnInit(): void {}
}
